import { render, staticRenderFns } from "./PaymentDialog.vue?vue&type=template&id=6b1857c4&"
import script from "./PaymentDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports